import React from 'react';
import Layout from '../../components/Layout';
const Messages: React.FC = () => {
  return <Layout title="Messages" persona="Student" data-id="element-4511">
      <div className="max-w-5xl mx-auto bg-white rounded-lg border border-gray-200 shadow-sm p-8" data-id="element-4512">
        <h2 className="text-xl font-medium text-gray-900 mb-6" data-id="element-4513">My Messages</h2>
        <p className="text-gray-600 mb-8" data-id="element-4514">
          This is a placeholder for the Student Messages page. The full
          implementation will include a messaging system to communicate with
          universities and program coordinators.
        </p>
      </div>
    </Layout>;
};
export default Messages;